import { useMemo } from 'react';
import { EqualityFn } from 'react-redux';

import { useAppDispatch, useAppSelector } from '@STORE/index';

import { editVariantModalSlice, EditVariantModalDispatchParams, EditVariantModalState } from '@REDUCERS';

function createEditVariantModalHook() {
    return function useEditVariantModal(equalityFn?: EqualityFn<EditVariantModalState>) {
        const state = useAppSelector((store) => store.editVariantModal, equalityFn);

        const dispatch = useAppDispatch();

        const actions = useMemo(() => ({
            open: (params: EditVariantModalDispatchParams) => dispatch(editVariantModalSlice.actions.open(params)),
            close: () => dispatch(editVariantModalSlice.actions.close()),
        }), [dispatch]);

        return {
            state,
            actions,
        };
    };
}

const useEditVariantModal = createEditVariantModalHook();

export default useEditVariantModal; 